import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FilterFooter } from '../../../elements/filter-footer';
import { Toggle } from '../../../elements/toggle';
import { RadioGroup } from '../../../elements/radio-group';
import { DatePicker } from '../../../elements/date-picker';
import { Select } from '../../../elements/select';


const initialValues = {
    name: '',
    identification_number: '',
    available: null
};

export const JobsFilter = ({
    item,
    doFilter,
    close
}: {
    item?: any;
    close: () => void;
    doFilter: (item: any) => void;
}) => {
    const { t } = useTranslation();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);

    const estados = [{ id: "PENDING", name: "PENDING" }, { id: "IN_PROGRESS", name: "IN_PROGRESS" }, { id: "COMPLETED", name: "COMPLETED" }]

    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        let after = { ...values };

        for (let key in after) {
            if (!after[key]) {
                delete after[key];
            }
        }

console.log('after', after)

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);

        doFilter(enviaremos);
    };

    useEffect(() => {
        if (state.error) {
            toast.error(state.error.detail);
        }
    }, [state]);

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={data || initialValues}
                validateOnBlur={true}
                onSubmit={onSubmit}
            >
                {({
                    values,
                    errors,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <DatePicker
                            name="date"
                            type="date"
                            label={t('common.labels.date')}
                            value={values.date}
                            onChange={(val: any) => setFieldValue('date', val.date ? dayjs(val.date).format('YYYY-MM-DD') : null)}
                        />
                        <Select
                            name="status"
                            label={t('common.label.estado')}
                            placeholder="Select value"
                            items={estados}
                            value={values.status?.id}
                            onChange={(value) =>
                                setFieldValue('status', value.status)
                            }
                        />

                        <FilterFooter
                            item={item}
                            doDelete={() => doFilter({})}
                            doSubmit={handleSubmit}
                            close={close}
                        />
                    </form>
                )}
            </Formik>
        </div>
    );
};